import { Seat } from "@ravalmatic/bridge-engine/core";
import { HandMode } from "../../Types";
import { Card } from "./Card";
import { GameVars } from "../../GameVars";

export interface PlayerLayout {
    position: { x: number; y: number };
    hand: { x: number; y: number; angle: number; duration?: number };
    avatar: { x: number; y: number; duration?: number };
}

export class BoardLayoutManager {

    public static readonly PORTRAIT_INFO_Y_RATIO = .78;
    public static readonly PORTRAIT_PLAY_INFO_OFFSET = 75;
    public static readonly PORTRAIT_PLAY_INFO_DURATION = 350;
    private static readonly NORTH_VISIBLE_HAND_OFFSET = 50;
    private static readonly PLAYER_AVATAR_OFFSET = 520;
    private static readonly AVATAR_MARGIN = 16;

    public getPlayerLayout(seat: Seat, mode: HandMode, width: number, height: number): PlayerLayout {

        const margin = Card.HEIGHT / 2;
        const northVisible = seat === 0 && mode !== HandMode.HIDDEN;
        const handY = northVisible ? BoardLayoutManager.NORTH_VISIBLE_HAND_OFFSET : 0;
        const positions = [
            { x: width / 2, y: margin * GameVars.scaleY },
            { x: width - margin, y: height / 2 },
            { x: width / 2, y: height - margin * GameVars.scaleY },
            { x: margin, y: height / 2 },
        ];
        const avatarPositions = [
            {
                x: northVisible ? -BoardLayoutManager.PLAYER_AVATAR_OFFSET : -370,
                y: northVisible ? handY + BoardLayoutManager.AVATAR_MARGIN : 0,
                duration: northVisible ? 500 : 0,
            },
            { x: -155, y: 0 },
            {
                x: GameVars.isLandscape ? BoardLayoutManager.PLAYER_AVATAR_OFFSET : width / 2 - 100,
                y: GameVars.isLandscape ? 0
                    : (height * BoardLayoutManager.PORTRAIT_INFO_Y_RATIO - positions[2].y) / GameVars.scaleY
            },
            { x: 155, y: 0 },
        ];

        return {
            position: positions[seat],
            hand: { x: 0, y: handY, angle: seat === 1 ? -90 : seat === 3 ? 90 : 0,
                duration: northVisible ? 500 : 0 },
            avatar: avatarPositions[seat],
        };
    }
}
